module.exports = __webpack_public_path__ + "static/hand-heart-icon-d32a4b5b6dc0a2aa849c3ce951b9a569.png";